(function (angular) {
    'use strict';

    angular.module('shared')
        .controller('sidebarController', ['$scope', 'jwtService', 'sharedDataService', 'apiSpacePicker', '$state', '$stateParams', 'utilService', '$sce', '$uibModal',
            function ($scope, jwtService, sharedDataService, apiSpacePicker, $state, $stateParams, utilService, $sce, $uibModal) {

                $scope.impersonate = jwtService.payload.impersonatorUserName;
                $scope.login = jwtService.payload.sub;
                $scope.checkState = function () {
                    return $state.current.name == 'apiSpace';
                };
                $scope.jwt = jwtService;
                $scope.apiSpacePicker = apiSpacePicker;
                $scope.pickedApiSpace = null;
                $scope.$on('apiSpacesUpdate:picked', function () {
                    $scope.pickedApiSpace = apiSpacePicker.getApiSpaces()[apiSpacePicker.getPicked()];

                    var currentApiSpaceId = $scope.pickedApiSpace.id;
                    console.info("Switched apispace to " + currentApiSpaceId);

                });
                        
                $scope.smsAdminPortalUrl = utilService.buildSmsUrl("/AdminPortal");
                $scope.smsSilentLogOnUrl = $sce.trustAsResourceUrl(utilService.buildSmsUrl("/DD/Security/Login/SilentLogOnJwt"));
                $scope.cpaasLogOnUrl = $sce.trustAsResourceUrl(utilService.buildCpaasAdminUrl("/login"));

                $scope.createBroadcast = function () {
                    $state.go("main.apiSpace.broadcastWizard", {
                        pickedApiSpaceId: $stateParams.pickedApiSpaceId,
                        broadcastId: utilService.uuid(),
                        new: true
                    }, {
                            reload: true
                        });
                };


            }]);

})(window.angular);
